export default function ($el) {
  const $donateButton = $el.find('.button');
  const $closeIcon = $el.find('.cw-icon-remove');
  let userScrollPos = 0;

  $donateButton.on('click', () => {
    userScrollPos = window.pageYOffset;
    $('body').css('top', -userScrollPos).toggleClass('banner-open');
    $('body').removeClass('banner-closing');
  });

  $closeIcon.on('click', () => {
    $('body').css('top', 0).toggleClass('banner-open');
    $('body').addClass('banner-closing');
    window.scrollTo(0, userScrollPos);

    setTimeout(() => {
      $('body').removeClass('banner-closing');
    }, 750);
  });
}
